import { render, staticRenderFns } from "./NotificationDashboard.vue?vue&type=template&id=39d261ce&scoped=true"
import script from "./NotificationDashboard.vue?vue&type=script&lang=js"
export * from "./NotificationDashboard.vue?vue&type=script&lang=js"
import style0 from "./NotificationDashboard.vue?vue&type=style&index=0&id=39d261ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d261ce",
  null
  
)

export default component.exports